<template>
<div style="height:100%;width:100%; display: flex;flex-direction: column;">

    <div style="height:50px;width:100%;background-color:#f8f8f8;">
    
    <div  style="color:#970B0B;margin-top:15px;width:100%;height:50px" class="container_right">
      
    <div style="width:40%;display:flex" > 
      <div style="width:4px;background-color:#970B0B;height:40px"></div> 
      <div style="margin:5px;color:#970B0B;">用户服务日志</div> 
    </div>
    <div style="width:50%;justify-content: center;display: flex;">
    </div>
    <div style="width:15%;color:#970B0B">
        <!-- <el-button  @click="RightAddClick"  size="mini"  style="width:70%;background-color:#970B0B;color:#fff">新增设备</el-button>  -->

    </div>

    </div>

    </div>

<div style="width:100%;height:100%">
  

                  

 <el-table 
    :data="groupIist"
     height="500px"
    size= "medium"
    :row-style="tableRowStyle"
    style="width: 100%;">
    <el-table-column
      fixed
      prop="id"
      label="ID"
      width="100">
    </el-table-column>

    <el-table-column
      prop="createTime"
      label="操作时间"
      width="200">
    </el-table-column>
    
        <el-table-column 
      prop="request_modularname"
      label="服务"
      width="100">
    </el-table-column>
        <el-table-column 
      prop="request_modular"
      label="服务名称"
      width="150">
    </el-table-column> 
       

    <el-table-column 
      prop="request_method"
      label="请求方式"
      width="150">
    </el-table-column>  
        <el-table-column 
      prop="request_path"
      label="接口地址"
      width="300">
    </el-table-column> 

    <el-table-column 
      prop="request_ip"
      label="IP地址"
      width="150">
    </el-table-column>  
 <el-table-column 
      prop="request_aid"
      label="用户AID"
      width="100">
    </el-table-column> 
        <el-table-column 
      prop="request_username"
      label="用户姓名"
      width="100">
    </el-table-column> 
        <el-table-column 
      prop="request_region"
      label="地域"
      width="300">
    </el-table-column> 
    

    </el-table-column>  
    <el-table-column 
      prop="request_os"
      label="系统"
      width="150">
    </el-table-column>  
    <el-table-column 
      prop="request_browser"
      label="浏览器"
      width="300">
          </el-table-column>  

          <el-table-column 
      prop="request_query"
      label="query参数"
      width="1200">
    </el-table-column>  
    <el-table-column 
      prop="request_body"
      label="body参数"
      width="600">
    </el-table-column>  

    <el-table-column 
      prop="response_code"
      label="返回状态"
      width="150">
    </el-table-column>  


    <el-table-column 
      prop="json_result"
      label="返回数据"
      width="150">
    </el-table-column>  





    <el-table-column
      fixed="right"
      label="操作"
      width="100">
     <template slot-scope="scope">
        <el-button
        disabled
          size="mini"
          @click="handleEdit(scope.$index, scope.row)">解析</el-button>

      </template>
    </el-table-column>

  </el-table>
  


</div>

 <el-pagination
      style="text-align:center;margin:10px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageInfo.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total">
</el-pagination>


<el-dialog
  :visible.sync="centerDialogVisible"
  width="80%"
  center
  :destroy-on-close = true
  :show-close = false
  :close-on-click-modal = false
  :close-on-press-escape = false
  >
<div>
      <div style="height:40px;width:100%;background-color:#fff;">
        <div  style="color:#970B0B;margin-top:15px;width:100%;height:40px" class="container_right">
          
            <div style="width:40%;display:flex" > 
              <div style="width:4px;background-color:#970B0B;height:40px"></div> 
              <div style="margin:5px;color:#970B0B;">日志解析</div> 
            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
        </div>
    </div>

        <div style="height:300px;width:100%;background-color:#f8f8f8;">
        <div  style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">
          
      
    <div style="width:100%;display:flex" > 
             
              

        <div style="display: flex;margin:10px;">
      <div style="flex: 1;">{{groupInfo.data}}</div>

      </div>

    
   </div>

      </div>
    </div>

</div>

  <span slot="footer" class="dialog-footer ">
    <el-button style="width:120px"  @click="centerDialogVisible = false">关 闭</el-button>
  </span>
</el-dialog>



</div>

</template>

<script>

import TMApipath from 'TMApipath'

import {formatTimestamp} from 'TMUtils'


  export default {
    methods: {
      handleSizeChange(val) {
        var _this =this;
        _this.pageInfo.size =  val;
        _this.getLogUserListByPage(_this.pageInfo.val,_this.pageInfo.size);
      },
      tableRowStyle() {
         return { "height": "20px" }
          
      },
      handleEdit(index, rows) {//待实现
        this.centerDialogVisible =  true;
        this.isGroupEdit =  true;

        console.log('rows:',rows)

        this.groupInfo = rows
      },
      handleCurrentChange(val){
        console.log(`当前页: ${val}`);
        var _this = this
        _this.pageInfo.val = val
        _this.getLogUserListByPage(_this.pageInfo.val,_this.pageInfo.size);

      },
      preclick(val){
        console.log(`当前页: ${val}`);

      },

     getLogUserListByPage(pageIndex, pageSize){

          var _this = this

          var reqdata = {pageIndex:pageIndex,pageSize:pageSize}
          var { urls} = _this.getresult(TMApipath.LOGSERVER, TMApipath.URL_API_GETLOGUSERLISTBYPAGE, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录
                _this.pageInfo.total = response.data.total

                _this.groupIist =[];

              for(var items in response.data.list){
                var item = response.data.list[items]

                    // if (item==null || !isJsonType(item.data)) {
                    //   console.log('result为null，或不是json')
                    //   return
                    // }
                    // var cc = JSON.parse(item.data);
                   


                var cutFeed ={
                  id: item.id,
                  request_aid: item.request_aid,
                  request_username: item.request_username,
                  request_region: item.request_region,

                  request_modularname: item.request_modularname,
                  request_modular: item.request_modular,
                  request_path: item.request_path,
                  request_query: item.request_query,
                  request_body: item.request_body,
                  request_method: item.request_method,
                  request_ip: item.request_ip,
                  request_browser: item.request_browser,
                  response_code: item.response_code,
                  request_os: item.request_os,
                  json_result: item.json_result,              
                  createTime: formatTimestamp(item.createDate)
                }

                _this.groupIist.push(cutFeed);
              }


            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },



    },
    mounted() {
      var _this = this
              _this.getLogUserListByPage(_this.pageInfo.val,_this.pageInfo.size);

    },
    data() {
      return {
        pageInfo:{
          val:1,
          size: 10,
          total:0
        },
        centerDialogVisible: false,
        isGroupEdit:false,
        groupInfo:{},
        groupIist: []
      }
    }
  }
</script>

<style lang="stylus" scoped>

.groups
    overflow: hidden

.rightButton
  width: 30px
.container_right
    margin: 5px
    display: flex
    justify-content: center
    align-items: flex-start
.el-dialog_header
    padding:0px
</style>